import { Component } from "@angular/core";

/**
 * Shell of every /administration/* page: displays the main navigation above the routed
 * administration page, the same way HomePageComponent does for /home/*.
 */
@Component({
  selector: "app-administration-layout",
  templateUrl: "./administration-layout.component.html",
  styleUrls: ["./administration-layout.component.scss"],
})
export class AdministrationLayoutComponent {}
